import { DatePipe } from '@angular/common';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, Validators, FormGroup } from '@angular/forms';
import each from 'lodash-es/each';
import filter from 'lodash-es/filter';

import { birthdateValidator } from 'src/app/validators/birthdate.validator';

@Component({
  selector: 'app-children-form',
  templateUrl: './children-form.component.html',
  styleUrls: ['./children-form.component.scss'],
  host: { 'class': 'table-responsive' },
  providers: [DatePipe]
})
export class ChildrenFormComponent implements OnInit {
  childrenForm: FormArray;
  validChild: boolean = false;
  validClearChild: boolean = false; // when user clear child by keyboard
  count = 0;
  currentInvalidChild: FormGroup = null;
  @Output() hasValidChildren = new EventEmitter<boolean>();
  @Output() data = new EventEmitter();
  constructor(private _formBuilder: FormBuilder, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.childrenForm = this._formBuilder.array([]);
    while (this.childrenForm.length < 4) {
      this.childrenForm.push(this.childForm);
    }
    this.hasValidChildren.emit(false);
    this.childrenForm.valueChanges.subscribe(res => {
      this.data.emit(this._parseChildren(res));
      this.hasValidChildren.emit(this.validChildren());
    })
  }

  hasFirstValidChild(index) {
    let invalid = true;
    each(this.childrenForm.controls, (child: FormGroup) => {
      if (child.valid) {
        invalid = false;
      }
    })
    if (index === 0) {
      return invalid;
    } else {
      return false;
    }
  }

  incompleteData(index: number): boolean {
    const child = this.childrenForm.at(index) as FormGroup;
    const nameValid = child.get('name').valid;
    const dobValid = child.get('dateOfBirth').valid;
    const genderValid = child.get('gender').valid;

    return (
      (nameValid && (!dobValid || !genderValid)) ||
      (dobValid && (!nameValid || !genderValid)) ||
      (genderValid && (!nameValid || !dobValid))
    );
  }

  otherValidChild(index) {
    let invalid = this.currentInvalidChild != null ? this.currentInvalidChild.invalid : false;
    let currentIndex = this.currentInvalidChild != null ? this.currentInvalidChild.get('id').value : 0;
    if (index !== 0 && currentIndex == index && invalid && !this.validClearChild) {
      return true;
    }
    else {
      return false;
    }
  }

  hasInvalidChildren(): boolean {
    let valid = true;
    each(this.childrenForm.controls, (child: FormGroup) => {
      const nameValid = child.get('name').valid;
      const dobValid = child.get('dateOfBirth').valid;
      const genderValid = child.get('gender').valid;

      if (
        (nameValid && (!dobValid || !genderValid)) ||
        (dobValid && (!nameValid || !genderValid)) ||
        (genderValid && (!nameValid || !dobValid))
      ) {
        valid = false;
      }
    });
    return valid;
  }

  validChildren() {
    let valid = false;
    each(this.childrenForm.controls, (child: FormGroup) => {
      if (child.get('name').valid && child.get('dateOfBirth').valid && child.get('gender').valid) {
        valid = true;
      }
    })
    return this.hasInvalidChildren() && valid;
  }

  _parseChildren(data: Array<any>) {
    return filter(data, (item: { name: string, dateOfBirth: any, gender: string, school: string, grade: string }) => {
      return item.name != null && item.name.length > 0 &&
        item.dateOfBirth != null && item.gender != null && item.gender.length > 0;
    });
  }

  private get childForm() {
    let child = this._formBuilder.group({
      name: ["", Validators.required],
      dateOfBirth: [null, [Validators.required, birthdateValidator]],
      gender: ["", Validators.required],
      school: [""],
      grade: [""],
      id: this.count++,
    });
    child.statusChanges.subscribe((res) => {
      this.validClearChild = child.valid;
      this.currentInvalidChild = child;
      if (child.get('name').invalid && child.get('dateOfBirth').invalid && child.get('gender').invalid) {
        this.validClearChild = true;
      }
      this.hasValidChildren.emit(this.validClearChild && this.validChildren());
    });
    return child;
  }

  removeChild(index) {
    each(this.childrenForm.controls, (child: FormGroup, key) => {
      if (index === key) {
        child.controls['name'].setValue('');
        child.controls['dateOfBirth'].setValue(null);
        child.controls['gender'].setValue('');
        child.controls['school'].setValue('');
        child.controls['grade'].setValue('');
      }
    });
  }
}
